import React from "react";

const Search = () => {
  return <div></div>;
};

export default Search;
